export default {
    // search limit popup
    tooManySearchRequests: "Too Many Search Requests",
    reachedTheLimitForRealTime: "You've reached the limit for “Real-time” search.",
    useTheRecentModeToExploreResults: "In the meantime, you can use the 'Recent' mode to explore results based solely on data already available in our database",
    btnTryLaterAgain: "Try again later",
    btnUseRecentMode: "Use recent mode",

    // Create New Sequence
    createNewSequence: 'Create New Sequence',
    sequenceName: "Sequence name",
    enterSequenceName: "Enter sequence name",

    // Not enough credits
    uDontHaveEnoughCredits: "You Don't Have Enough Credits",
    addMinimumCredits: "Would you like to add {count} top-up credits (the minimum recharge amount) to continue your search?",
    btnAddCredits: "Add Credits",

    // Payment Method Required
    paymentMethodRequired: "Payment Method Required",
    dontHaveAPaymentMethodLinkedToYourAccount: 'It looks like you don’t have a payment method linked to your account.',
    pleaseAddYourPaymentMethodToContinue: "Please add your payment method to continue.",
    btnAddNow: 'Add Now',


    // Credit Running Low!
    creditRunningLow: "Credit Running Low!",
    yourCreditIsRunningLow: "Your credit is running low, and we couldn’t process an auto top-up.",
    pleaseManuallyTopupYourCredit: "Please manually top up your credit to avoid interruptions to your service.",
    btnTopup: "Top-up Now",

    // You've Reached Your Limit
    uHaveReachedYourLimit: "You've Reached Your Limit",
    subscriptionTiers: "Subscription Tiers",
    switchPlansSeamlessly: "Switch plans seamlessly — your remaining credits will transfer as top-up credits for future use.",
    tabMonthly: "Monthly",
    tabAnnual: "Annual",
    tableFieldCredits: "Credits",
    tableFieldTopupCredit: 'Top-up credit',
    tableFieldPageLimit: "Page Limit",
    tableFieldExportLimit: "Export Limit",
    tableFieldAPI: "API",
    tableFieldRolePermission: 'Custom Role Permission',
    tableFieldTeamManagement: "Team Management",
    tableFieldPrice: "Price - Per user, per month Billed",
    tableFieldFeatures: "Features",
    titleTiers: "Tiers",
    btnChangePlan: 'Change Plan',
    btnCurrentPlan: 'Current',


    // Upgrade to Unlock This Feature
    upgradeToUnlockThisFeature: "Upgrade to Unlock This Feature",
    thisFeatureIsAvailableOnlyForUpgradedPlanUsers: 'This feature is available only for upgraded plan users.',
    upgradeYourPlanToEnjoyEnhancedFunctionality: 'Upgrade your plan to enjoy enhanced functionality and unlock more possibilities tailored to your needs.',
    btnBack: 'Back',
    btnUpgradeNow: 'Upgrade Now'


};